import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningLead } from '../components/OpeningLead';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { SolutionSection } from '../components/SolutionSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="min-h-screen" style={{
    backgroundColor: '#0a1628'
  }} data-id="element-206">
      <HeroSection data-id="element-207" />
      <OpeningLead data-id="element-208" />
      <ProblemSection data-id="element-209" />
      <MechanismSection data-id="element-210" />
      <SolutionSection data-id="element-211" />
      <OfferSection data-id="element-212" />
      <GuaranteeSection data-id="element-213" />
      <FinalCTA data-id="element-214" />
      <Footer data-id="element-215" />
    </main>;
}